export var Sword;
(function (Sword) {
    Sword["BallpointPen"] = "ballpoint_pen";
    Sword["Bbq"] = "bbq";
    Sword["BurgerDay2023"] = "burger_day2023";
    Sword["ButterflyWand"] = "butterfly_wand";
    Sword["Cardboard"] = "cardboard";
    Sword["Crayon"] = "crayon";
    Sword["DuckWand"] = "duck_wand";
    Sword["EmojiWand"] = "emoji_wand";
    Sword["Fish"] = "fish";
    Sword["Flower"] = "flower";
    Sword["FountainPen"] = "fountain_pen";
    Sword["Laser"] = "laser";
    Sword["Leaf"] = "leaf";
    Sword["LollipopWand"] = "lollipop_wand";
    Sword["LovelyWand"] = "lovely_wand";
    Sword["MagicWand"] = "magic_wand";
    Sword["Marker"] = "marker";
    Sword["Night"] = "night";
    Sword["PaintBrush"] = "paint_brush";
    Sword["PrideSword2023"] = "pride_sword2023";
    Sword["PrideWand2023"] = "pride_wand2023";
    Sword["SchoolApple2023"] = "school_apple2023";
    Sword["SchoolBulb2023"] = "school_bulb2023";
    Sword["SchoolChemistry2023"] = "school_chemistry2023";
    Sword["SchoolDna2023"] = "school_dna2023";
    Sword["Pencil"] = "pencil";
    Sword["PoopWand"] = "poop_wand";
    Sword["Ruler"] = "ruler";
    Sword["SnowWand"] = "snow_wand";
    Sword["SodaWand"] = "soda_wand";
    Sword["Time"] = "time";
    Sword["UnicornWand"] = "unicorn_wand";
    Sword["Wood"] = "wood";
    Sword["HalloweenGhost2023"] = "halloween_ghost2023";
    Sword["HalloweenPumpkinSword2023"] = "halloween_pumpkin_sword2023";
    Sword["HalloweenPumpkinWand2023"] = "halloween_pumpkin_wand2023";
    Sword["HalloweenWeb2023"] = "halloween_web2023";
    Sword["Watermelon"] = "watermelon";
    Sword["Acorn"] = "acorn";
    Sword["Baguette"] = "baguette";
    Sword["Balloon"] = "balloon";
    Sword["Banana"] = "banana";
    Sword["Bat"] = "bat";
    Sword["Boba"] = "boba";
    Sword["Bone"] = "bone";
    Sword["Bubble"] = "bubble";
    Sword["Bud"] = "bud";
    Sword["Cactus"] = "cactus";
    Sword["Carrot"] = "carrot";
    Sword["Cat"] = "cat";
    Sword["ChristmasCandy"] = "christmas_candy";
    Sword["ChristmasChimney"] = "christmas_chimney";
    Sword["ChristmasSnowman"] = "christmas_snowman";
    Sword["ChristmasTree"] = "christmas_tree";
    Sword["Claw"] = "claw";
    Sword["Coin"] = "coin";
    Sword["Crown"] = "crown";
    Sword["Cupcake"] = "cupcake";
    Sword["DinoGreen"] = "dino_green";
    Sword["DinoRed"] = "dino_red";
    Sword["Dog"] = "dog";
    Sword["EasterBunny2024"] = "easter_bunny2024";
    Sword["EasterEgg2024"] = "easter_egg2024";
    Sword["EasterFeather2024"] = "easter_feather2024";
    Sword["EasterNest2024"] = "easter_nest2024";
    Sword["FirebreathBig"] = "firebreath_big";
    Sword["FirebreathSmall"] = "firebreath_small";
    Sword["Fork"] = "fork";
    Sword["Game"] = "game";
    Sword["Gill"] = "gill";
    Sword["Grabber"] = "grabber";
    Sword["Hat"] = "hat";
    Sword["Heart"] = "heart";
    Sword["Ice"] = "ice";
    Sword["Jellyfish"] = "jellyfish";
    Sword["Lava"] = "lava";
    Sword["Lucky"] = "lucky";
    Sword["Meteor"] = "meteor";
    Sword["Moon"] = "moon";
    Sword["Mushroom"] = "mushroom";
    Sword["Mysterious"] = "mysterious";
    Sword["Ninja"] = "ninja";
    Sword["Octopus"] = "octopus";
    Sword["Pineapple"] = "pineapple";
    Sword["Pizza"] = "pizza";
    Sword["Plant"] = "plant";
    Sword["Plunger"] = "plunger";
    Sword["PrideMaypole"] = "pride_maypole";
    Sword["PridePopsicle"] = "pride_popsicle";
    Sword["Rabbit"] = "rabbit";
    Sword["Rainbow"] = "rainbow";
    Sword["Ribbon"] = "ribbon";
    Sword["Seashell"] = "seashell";
    Sword["Star"] = "star";
    Sword["Stone"] = "stone";
    Sword["Teapot"] = "teapot";
    Sword["Trash"] = "trash";
    Sword["Trident"] = "trident";
    Sword["Trumpet"] = "trumpet";
})(Sword || (Sword = {}));
export const SwordSet = {
    [Sword.Bbq]: {
        name: Sword.Bbq,
        price: 800,
    },
    [Sword.BallpointPen]: {
        name: Sword.BallpointPen,
        price: 500,
    },
    [Sword.BurgerDay2023]: {
        name: Sword.BurgerDay2023,
        price: 0,
    },
    [Sword.ButterflyWand]: {
        name: Sword.ButterflyWand,
        price: 1000,
    },
    [Sword.Cardboard]: {
        name: Sword.Cardboard,
        price: 300,
    },
    [Sword.Crayon]: {
        name: Sword.Crayon,
        price: 300,
    },
    [Sword.DuckWand]: {
        name: Sword.DuckWand,
        price: 1800,
    },
    [Sword.EmojiWand]: {
        name: Sword.EmojiWand,
        price: 800,
    },
    [Sword.Fish]: {
        name: Sword.Fish,
        price: 1200,
    },
    [Sword.Flower]: {
        name: Sword.Flower,
        price: 1200,
    },
    [Sword.FountainPen]: {
        name: Sword.FountainPen,
        price: 800,
    },
    [Sword.Laser]: {
        name: Sword.Laser,
        price: 1000,
    },
    [Sword.Leaf]: {
        name: Sword.Leaf,
        price: 800,
    },
    [Sword.LollipopWand]: {
        name: Sword.LollipopWand,
        price: 600,
    },
    [Sword.LovelyWand]: {
        name: Sword.LovelyWand,
        price: 1000,
    },
    [Sword.MagicWand]: {
        name: Sword.MagicWand,
        price: 500,
    },
    [Sword.Marker]: {
        name: Sword.Marker,
        price: 500,
    },
    [Sword.Night]: {
        name: Sword.Night,
        price: 1500,
    },
    [Sword.PaintBrush]: {
        name: Sword.PaintBrush,
        price: 1000,
    },
    [Sword.PrideSword2023]: {
        name: Sword.PrideSword2023,
        price: 0,
    },
    [Sword.PrideWand2023]: {
        name: Sword.PrideWand2023,
        price: 0,
    },
    [Sword.Pencil]: {
        name: Sword.Pencil,
        price: 0,
    },
    [Sword.PoopWand]: {
        name: Sword.PoopWand,
        price: 2000,
    },
    [Sword.Ruler]: {
        name: Sword.Ruler,
        price: 500,
    },
    [Sword.SnowWand]: {
        name: Sword.SnowWand,
        price: 800,
    },
    [Sword.SodaWand]: {
        name: Sword.SodaWand,
        price: 800,
    },
    [Sword.Time]: {
        name: Sword.Time,
        price: 1000,
    },
    [Sword.UnicornWand]: {
        name: Sword.UnicornWand,
        price: 1500,
    },
    [Sword.Wood]: {
        name: Sword.Wood,
        price: 400,
    },
    [Sword.SchoolApple2023]: {
        name: Sword.SchoolApple2023,
        price: 0,
    },
    [Sword.SchoolBulb2023]: {
        name: Sword.SchoolBulb2023,
        price: 0,
    },
    [Sword.SchoolChemistry2023]: {
        name: Sword.SchoolChemistry2023,
        price: 0,
    },
    [Sword.SchoolDna2023]: {
        name: Sword.SchoolDna2023,
        price: 0,
    },
    [Sword.HalloweenGhost2023]: {
        name: Sword.HalloweenGhost2023,
        price: 1100,
    },
    [Sword.HalloweenWeb2023]: {
        name: Sword.HalloweenWeb2023,
        price: 600,
    },
    [Sword.HalloweenPumpkinSword2023]: {
        name: Sword.HalloweenPumpkinSword2023,
        price: 1600,
    },
    [Sword.HalloweenPumpkinWand2023]: {
        name: Sword.HalloweenPumpkinWand2023,
        price: 2100,
    },
    [Sword.Watermelon]: {
        name: Sword.Watermelon,
        price: 1000,
    },
    [Sword.Acorn]: {
        name: Sword.Acorn,
        price: 600,
    },
    [Sword.Baguette]: {
        name: Sword.Baguette,
        price: 600,
    },
    [Sword.Balloon]: {
        name: Sword.Balloon,
        price: 600,
    },
    [Sword.Banana]: {
        name: Sword.Banana,
        price: 1000,
    },
    [Sword.Bat]: {
        name: Sword.Bat,
        price: 3000,
    },
    [Sword.Boba]: {
        name: Sword.Boba,
        price: 1100,
    },
    [Sword.Bone]: {
        name: Sword.Bone,
        price: 700,
    },
    [Sword.Bubble]: {
        name: Sword.Bubble,
        price: 700,
    },
    [Sword.Bud]: {
        name: Sword.Bud,
        price: 1400,
    },
    [Sword.Cactus]: {
        name: Sword.Cactus,
        price: 700,
    },
    [Sword.Carrot]: {
        name: Sword.Carrot,
        price: 700,
    },
    [Sword.Cat]: {
        name: Sword.Cat,
        price: 800,
    },
    [Sword.ChristmasCandy]: {
        name: Sword.ChristmasCandy,
        price: 1100,
    },
    [Sword.ChristmasChimney]: {
        name: Sword.ChristmasChimney,
        price: 1600,
    },
    [Sword.ChristmasSnowman]: {
        name: Sword.ChristmasSnowman,
        price: 600,
    },
    [Sword.ChristmasTree]: {
        name: Sword.ChristmasTree,
        price: 2100,
    },
    [Sword.Claw]: {
        name: Sword.Claw,
        price: 800,
    },
    [Sword.Coin]: {
        name: Sword.Coin,
        price: 1800,
    },
    [Sword.Crown]: {
        name: Sword.Crown,
        price: 9999,
    },
    [Sword.Cupcake]: {
        name: Sword.Cupcake,
        price: 800,
    },
    [Sword.DinoGreen]: {
        name: Sword.DinoGreen,
        price: 900,
    },
    [Sword.DinoRed]: {
        name: Sword.DinoRed,
        price: 1300,
    },
    [Sword.Dog]: {
        name: Sword.Dog,
        price: 800,
    },
    [Sword.EasterBunny2024]: {
        name: Sword.EasterBunny2024,
        price: 0,
    },
    [Sword.EasterEgg2024]: {
        name: Sword.EasterEgg2024,
        price: 0,
    },
    [Sword.EasterFeather2024]: {
        name: Sword.EasterFeather2024,
        price: 0,
    },
    [Sword.EasterNest2024]: {
        name: Sword.EasterNest2024,
        price: 0,
    },
    [Sword.FirebreathBig]: {
        name: Sword.FirebreathBig,
        price: 1100,
    },
    [Sword.FirebreathSmall]: {
        name: Sword.FirebreathSmall,
        price: 1100,
    },
    [Sword.Fork]: {
        name: Sword.Fork,
        price: 700,
    },
    [Sword.Game]: {
        name: Sword.Game,
        price: 1100,
    },
    [Sword.Gill]: {
        name: Sword.Gill,
        price: 1100,
    },
    [Sword.Grabber]: {
        name: Sword.Grabber,
        price: 1200,
    },
    [Sword.Hat]: {
        name: Sword.Hat,
        price: 1200,
    },
    [Sword.Heart]: {
        name: Sword.Heart,
        price: 1400,
    },
    [Sword.Ice]: {
        name: Sword.Ice,
        price: 1700,
    },
    [Sword.Jellyfish]: {
        name: Sword.Jellyfish,
        price: 1600,
    },
    [Sword.Lava]: {
        name: Sword.Lava,
        price: 1900,
    },
    [Sword.Lucky]: {
        name: Sword.Lucky,
        price: 1700,
    },
    [Sword.Meteor]: {
        name: Sword.Meteor,
        price: 1600,
    },
    [Sword.Moon]: {
        name: Sword.Moon,
        price: 1800,
    },
    [Sword.Mushroom]: {
        name: Sword.Mushroom,
        price: 700,
    },
    [Sword.Mysterious]: {
        name: Sword.Mysterious,
        price: 1500,
    },
    [Sword.Ninja]: {
        name: Sword.Ninja,
        price: 1500,
    },
    [Sword.Octopus]: {
        name: Sword.Octopus,
        price: 1900,
    },
    [Sword.Pineapple]: {
        name: Sword.Pineapple,
        price: 1200,
    },
    [Sword.Pizza]: {
        name: Sword.Pizza,
        price: 1000,
    },
    [Sword.Plant]: {
        name: Sword.Plant,
        price: 900,
    },
    [Sword.Plunger]: {
        name: Sword.Plunger,
        price: 600,
    },
    [Sword.PrideMaypole]: {
        name: Sword.PrideMaypole,
        price: 1000,
    },
    [Sword.PridePopsicle]: {
        name: Sword.PridePopsicle,
        price: 1000,
    },
    [Sword.Rabbit]: {
        name: Sword.Rabbit,
        price: 1600,
    },
    [Sword.Rainbow]: {
        name: Sword.Rainbow,
        price: 1300,
    },
    [Sword.Ribbon]: {
        name: Sword.Ribbon,
        price: 3000,
    },
    [Sword.Seashell]: {
        name: Sword.Seashell,
        price: 4000,
    },
    [Sword.Star]: {
        name: Sword.Star,
        price: 2000,
    },
    [Sword.Stone]: {
        name: Sword.Stone,
        price: 1300,
    },
    [Sword.Teapot]: {
        name: Sword.Teapot,
        price: 1600,
    },
    [Sword.Trash]: {
        name: Sword.Trash,
        price: 600,
    },
    [Sword.Trident]: {
        name: Sword.Trident,
        price: 1800,
    },
    [Sword.Trumpet]: {
        name: Sword.Trumpet,
        price: 1100,
    },
};
export var Days;
(function (Days) {
    Days[Days["Monday"] = 1] = "Monday";
    Days[Days["Tuesday"] = 2] = "Tuesday";
    Days[Days["Wednesday"] = 3] = "Wednesday";
    Days[Days["Thursday"] = 4] = "Thursday";
    Days[Days["Friday"] = 5] = "Friday";
    Days[Days["Saturday"] = 6] = "Saturday";
    Days[Days["Sunday"] = 7] = "Sunday";
})(Days || (Days = {}));
export var ShopStatus;
(function (ShopStatus) {
    ShopStatus["Construction"] = "construction";
    ShopStatus["Open"] = "open";
    ShopStatus["Closed"] = "closed";
})(ShopStatus || (ShopStatus = {}));
export var Costume;
(function (Costume) {
    Costume["Astronaut"] = "astronaut";
    Costume["Beach"] = "beach";
    Costume["Bear"] = "bear";
    Costume["Bee"] = "bee";
    Costume["Chef"] = "chef";
    Costume["Clown"] = "clown";
    Costume["ColorBomb"] = "colorBomb";
    Costume["Cowboy"] = "cowboy";
    Costume["Firefighter"] = "firefighter";
    Costume["ForestFairy"] = "forestFairy";
    Costume["Mage"] = "mage";
    Costume["Mermaid"] = "mermaid";
    Costume["Pencil"] = "pencil";
    Costume["Pirate"] = "pirate";
    Costume["Police"] = "police";
    Costume["Poseidon"] = "poseidon";
    Costume["Princess1"] = "princess1";
    Costume["Princess2"] = "princess2";
    Costume["Robot"] = "robot";
    Costume["Superhero"] = "superhero";
    Costume["Witch"] = "witch";
})(Costume || (Costume = {}));
export var CostumeType;
(function (CostumeType) {
    CostumeType["Hat"] = "hat";
    CostumeType["Body"] = "body";
})(CostumeType || (CostumeType = {}));
export const CostumeSet = {
    [`${Costume.Bear}+${CostumeType.Hat}`]: {
        item: {
            name: Costume.Bear,
            type: CostumeType.Hat,
        },
        price: 300,
    },
    [`${Costume.Bear}+${CostumeType.Body}`]: {
        item: {
            name: Costume.Bear,
            type: CostumeType.Body,
        },
        price: 800,
    },
    [`${Costume.Princess1}+${CostumeType.Hat}`]: {
        item: {
            name: Costume.Princess1,
            type: CostumeType.Hat,
        },
        price: 400,
    },
    [`${Costume.Princess1}+${CostumeType.Body}`]: {
        item: {
            name: Costume.Princess1,
            type: CostumeType.Body,
        },
        price: 1200,
    },
    [`${Costume.ForestFairy}+${CostumeType.Hat}`]: {
        item: {
            name: Costume.ForestFairy,
            type: CostumeType.Hat,
        },
        price: 500,
    },
    [`${Costume.ForestFairy}+${CostumeType.Body}`]: {
        item: {
            name: Costume.ForestFairy,
            type: CostumeType.Body,
        },
        price: 1600,
    },
};
//# sourceMappingURL=Customisation.js.map